<dx-select-box
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  width="100%"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-select-box
  *ngIf="isWarrantyClass"
  valueExpr="key"
  label="{{ 'WARRANTY_ClASS' | translate }}"
  width="100%"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="warrantyClasses"
  [searchEnabled]="true"
  [acceptCustomValue]="true"
  [(value)]="templateItem.defaultValue"
  (onSelectionChanged)="update()"
/>

<dx-select-box
  *ngIf="isHazmatClass"
  valueExpr="key"
  label="{{ 'HAZMAT_ClASS' | translate }}"
  width="100%"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="hazmatClasses"
  [searchEnabled]="true"
  [(value)]="templateItem.defaultValue"
  [acceptCustomValue]="true"
  (onSelectionChanged)="update()"
/>

<!--<np-booleanRadioGroup
  *ngIf="isRadioGroupItem"
  [templateView]="false"
  [readOnly]="false"
  [fieldName]="pimField.field"
  validatorValidationGroup="LEGAL"
></np-booleanRadioGroup>-->
